import React, { useState } from 'react';
import { linkGoogle, signOutUser } from '../auth';
import { showToast } from '../utils/feedback';

// Small account control shown at the top of the card. Everyone rates as an
// anonymous guest; this lets them optionally upgrade to a permanent Google
// account so their ratings persist across devices and browser resets.
function AuthBar({ user }) {
  const [busy, setBusy] = useState(false);

  const handleSignIn = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await linkGoogle();
      showToast('Signed in — your ratings are saved! ✅');
    } catch (err) {
      // Ignore user-cancelled popups; surface anything else.
      if (
        err.code !== 'auth/popup-closed-by-user' &&
        err.code !== 'auth/cancelled-popup-request'
      ) {
        console.error('Sign-in failed:', err);
        showToast(
          err.code && err.code.startsWith('auth/')
            ? 'Sign-in is unavailable right now.'
            : 'Something went wrong.'
        );
      }
    } finally {
      setBusy(false);
    }
  };

  const handleSignOut = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await signOutUser();
    } finally {
      setBusy(false);
    }
  };

  const wrap = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 10,
    minHeight: 26,
    marginBottom: 4,
  };

  // Auth still resolving — reserve the row to avoid a layout jump.
  if (!user) return <div style={wrap} />;

  if (user.isAnonymous) {
    return (
      <div style={wrap}>
        <button type="button" onClick={handleSignIn} disabled={busy} style={pillBtn}>
          {busy ? 'Signing in…' : 'Sign in to save your ratings'}
        </button>
      </div>
    );
  }

  const name = user.displayName || user.email || 'you';
  return (
    <div style={wrap}>
      <span style={{ fontSize: 13, color: '#98989d' }}>Signed in as {name}</span>
      <button type="button" onClick={handleSignOut} disabled={busy} style={linkBtn}>
        Sign out
      </button>
    </div>
  );
}

const pillBtn = {
  fontSize: 13,
  fontWeight: 600,
  color: '#0a84ff',
  background: 'rgba(10,132,255,.18)',
  border: 'none',
  padding: '7px 13px',
  borderRadius: 999,
  cursor: 'pointer',
};

const linkBtn = {
  fontSize: 13,
  fontWeight: 600,
  color: '#0a84ff',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
};

export default AuthBar;
